import editorialSource from '../../content/discover-editorial';
import spotlight from './discoverSpotlight.cjs';

const { normalizeSpotlightBooks } = spotlight;

/** Read deployment-managed Spotlight picks independently of hosted editorial issue dates. */
export const getBundledSpotlightBooks = (source = editorialSource) =>
  normalizeSpotlightBooks(source?.backInSpotlight, 'Bundled Discover Back in the Spotlight');
